import { render, staticRenderFns } from "./CrmLead.vue?vue&type=template&id=b96ebf8e&scoped=true&"
import script from "./CrmLead.vue?vue&type=script&lang=js&"
export * from "./CrmLead.vue?vue&type=script&lang=js&"
import style0 from "./CrmLead.vue?vue&type=style&index=0&id=b96ebf8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96ebf8e",
  null
  
)

export default component.exports